function klaviyoDataLayer() {
  // Private array
  var array = [];

  // Callback function to be executed when an element is added
  var onElementAdded = function(element) {
    // Do something with the added element
  
  };

  // Public method to add an element to the array
  this.push = function(element) {
    array.push(element);
    // Call the callback function
    onElementAdded(element);
  };

  // Public method to retrieve the array
  this.getArray = function() {
    return array;
  };

  // Public method to set the callback function
  this.onElementAdded = function(callback) {
    onElementAdded = callback;
  };
}

// Usage
window.klaviyoDataLayer = new klaviyoDataLayer();
window.klaviyoDataLayer.onElementAdded(async function(element) {

  

  if (element.event === 'productView') {
 
   let event = _learnq.push(['track', "Shopify: Viewed Product", element.data]);

  }

  if (element.event === 'addToCart') {

 let event = _learnq.push(['track', "Shopify: Added to cart", element.data]);


    
  }
});
